import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { ModalDismissButtonComponent } from './modal-dismiss-button/modal-dismiss-button.component';
import { SignComponent } from './sign/sign.component';
import { LayoutModule } from '../layout/layout.module';
import { ImageViewComponent } from './image-view/image-view.component';
import { CompanyComponent } from './company/company.component';
import { InputModule } from '../input/input.module';


@NgModule({
  declarations: [
    CompanyComponent,
    ImageViewComponent,
    ModalDismissButtonComponent,
    SignComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    PipesModule,
    RouterModule,
    LayoutModule,
    InputModule
  ],
  exports: [
    CompanyComponent,
    ImageViewComponent,
    ModalDismissButtonComponent,
    SignComponent
  ]
})
export class ModalModule { }
